var styles = {"viewMode":"pnARF","editMode":"yXT2Q","container":"i97Uq","cell":"HOcJ4"};

export { styles as s };

import 'wix-rich-content-plugin-table/dist/loadable/viewer/es/styles.viewer.min.global.css'